<div mat-dialog-content>
  <div>
      <p>
          {{data.reason}}
      </p>
  </div>
</div>


<div *ngIf="data.status === 515" mat-dialog-actions>
  <button mat-button (click)="onSignIn()">{{'SIGN-IN-AGAIN' | translate}}</button>
  <button mat-button [mat-dialog-close]="onClose()" cdkFocusInitial>{{'EXIT' | translate}}</button>
</div>
